import React, { useState, useEffect } from 'react';
import axios from './lib/axiosClient';

const S = {
  bg: '#0f0f11', panel: '#16161a', border: '#2a2a35', text: '#f0f0f2',
  muted: '#7a7a8a', amber: '#f5a623', green: '#3ecf8e', red: '#e8484a',
};
const inp = { width: '100%', padding: '9px 12px', background: '#1a1a22', border: '1px solid ' + S.border, borderRadius: 8, color: S.text, fontSize: 14, boxSizing: 'border-box', outline: 'none' };

export default function VendorsPage() {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editVendor, setEditVendor] = useState(null);
  const [search, setSearch] = useState('');
  const [form, setForm] = useState({ name: '', contact_name: '', phone: '', email: '', address: '', category: '', notes: '' });

  useEffect(() => { load(); }, []);

  async function load() {
    setLoading(true);
    try { const r = await axios.get('/api/vendors'); setVendors(r.data.vendors || []); } catch(e) { setVendors([]); }
    setLoading(false);
  }

  async function save() {
    if (!form.name) return;
    try {
      if (editVendor) await axios.put('/api/vendors/' + editVendor.id, form);
      else await axios.post('/api/vendors', form);
      setShowModal(false); setEditVendor(null);
      setForm({ name: '', contact_name: '', phone: '', email: '', address: '', category: '', notes: '' });
      load();
    } catch(e) {}
  }

  async function del(id) {
    if (!window.confirm('Delete vendor?')) return;
    await axios.delete('/api/vendors/' + id); load();
  }

  function openEdit(v) {
    setEditVendor(v);
    setForm({ name: v.name||'', contact_name: v.contact_name||'', phone: v.phone||'', email: v.email||'', address: v.address||'', category: v.category||'', notes: v.notes||'' });
    setShowModal(true);
  }

  const filtered = vendors.filter(v => !search || v.name.toLowerCase().includes(search.toLowerCase()) || (v.contact_name||'').toLowerCase().includes(search.toLowerCase()));

  return (
    <div style={{ padding: 24, background: S.bg, minHeight: '100vh', color: S.text }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800 }}>🚚 Vendors</div>
          <div style={{ fontSize: 13, color: S.muted, marginTop: 2 }}>Manage your suppliers and partners</div>
        </div>
        <button onClick={() => { setEditVendor(null); setForm({ name: '', contact_name: '', phone: '', email: '', address: '', category: '', notes: '' }); setShowModal(true); }}
          style={{ padding: '8px 18px', background: S.amber, color: '#000', border: 'none', borderRadius: 8, fontWeight: 700, cursor: 'pointer' }}>+ Add Vendor</button>
      </div>

      <input value={search} onChange={e => setSearch(e.target.value)} placeholder="🔍 Search vendors..."
        style={{ ...inp, marginBottom: 20, maxWidth: 400 }} />

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 16 }}>
        {loading ? <div style={{ color: S.muted }}>Loading...</div> : filtered.map(v => (
          <div key={v.id} style={{ background: S.panel, border: '1px solid ' + S.border, borderRadius: 12, padding: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
              <div style={{ fontSize: 15, fontWeight: 800 }}>{v.name}</div>
              {v.category && <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 5, background: 'rgba(245,166,35,0.15)', color: S.amber }}>{v.category}</span>}
            </div>
            {v.contact_name && <div style={{ fontSize: 12, color: S.muted, marginBottom: 4 }}>👤 {v.contact_name}</div>}
            {v.phone && <div style={{ fontSize: 12, color: S.muted, marginBottom: 4 }}>📞 {v.phone}</div>}
            {v.email && <div style={{ fontSize: 12, color: S.muted, marginBottom: 4 }}>✉️ {v.email}</div>}
            {v.address && <div style={{ fontSize: 12, color: S.muted, marginBottom: 4 }}>📍 {v.address}</div>}
            {v.notes && <div style={{ fontSize: 12, color: S.muted, marginTop: 8, fontStyle: 'italic' }}>{v.notes}</div>}
            <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
              <button onClick={() => openEdit(v)} style={{ flex: 1, padding: '7px', background: 'transparent', border: '1px solid ' + S.border, borderRadius: 8, color: S.muted, cursor: 'pointer', fontWeight: 600, fontSize: 12 }}>Edit</button>
              <button onClick={() => del(v.id)} style={{ padding: '7px 14px', background: 'rgba(232,72,74,0.1)', border: '1px solid rgba(232,72,74,0.2)', borderRadius: 8, color: S.red, cursor: 'pointer', fontWeight: 600, fontSize: 12 }}>Delete</button>
            </div>
          </div>
        ))}
        {!loading && filtered.length === 0 && <div style={{ color: S.muted, padding: 40 }}>No vendors found</div>}
      </div>

      {showModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: S.panel, border: '1px solid ' + S.border, borderRadius: 14, padding: 28, width: 460, maxWidth: '95vw', maxHeight: '90vh', overflow: 'auto' }}>
            <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 20 }}>{editVendor ? 'Edit Vendor' : '+ New Vendor'}</div>
            {[['Company Name *', 'name', 'text'], ['Contact Name', 'contact_name', 'text'], ['Phone', 'phone', 'tel'], ['Email', 'email', 'email'], ['Address', 'address', 'text'], ['Category', 'category', 'text']].map(([label, key, type]) => (
              <div key={key} style={{ marginBottom: 12 }}>
                <div style={{ fontSize: 11, fontWeight: 600, color: S.muted, textTransform: 'uppercase', marginBottom: 4 }}>{label}</div>
                <input type={type} value={form[key]} onChange={e => setForm(f => ({...f, [key]: e.target.value}))} style={inp} />
              </div>
            ))}
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: S.muted, textTransform: 'uppercase', marginBottom: 4 }}>Notes</div>
              <textarea value={form.notes} onChange={e => setForm(f => ({...f, notes: e.target.value}))} style={{...inp, minHeight: 60, resize: 'vertical'}} />
            </div>
            <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
              <button onClick={() => { setShowModal(false); setEditVendor(null); }} style={{ flex: 1, padding: 12, background: 'transparent', color: S.muted, border: '1px solid ' + S.border, borderRadius: 10, fontWeight: 600, cursor: 'pointer' }}>Cancel</button>
              <button onClick={save} style={{ flex: 2, padding: 12, background: S.amber, color: '#000', border: 'none', borderRadius: 10, fontWeight: 800, cursor: 'pointer' }}>Save Vendor</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
